(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function bindFooterAccordions(root) {
    const scope = root || document;
    scope.querySelectorAll('.av-footer-toggle').forEach((button) => {
      if (button.dataset.avBound === 'true') return;
      button.dataset.avBound = 'true';

      const applyViewportState = () => {
        if (mobileQuery.matches) {
          if (button.dataset.avMobileReady !== 'true') {
            button.setAttribute('aria-expanded', 'false');
            button.dataset.avMobileReady = 'true';
          }
        } else {
          button.setAttribute('aria-expanded', 'true');
          delete button.dataset.avMobileReady;
        }
      };

      button.addEventListener('click', () => {
        if (!mobileQuery.matches) return;
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
      });

      if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', applyViewportState);
      } else {
        mobileQuery.addListener(applyViewportState);
      }
      applyViewportState();
    });
  }

  function visiblePrice(productInfo) {
    const candidates = productInfo.querySelectorAll(
      '.price-item--sale.price-item--last, .price-item--regular'
    );
    for (const candidate of candidates) {
      if (candidate.textContent.trim() && candidate.offsetParent !== null) {
        return candidate.textContent.trim().replace(/\s+/g, ' ');
      }
    }
    return '';
  }

  function setupStickyCart() {
    const existing = document.getElementById('av-mobile-sticky-cart');
    if (existing) existing.remove();
    document.body.classList.remove('av-sticky-cart-active');

    const productInfo =
      document.querySelector('product-info[id^="MainProduct-"]') ||
      document.querySelector('product-info');
    if (!productInfo) return;

    const originalButton = productInfo.querySelector('.product-form__submit');
    if (!originalButton) return;

    const bar = document.createElement('aside');
    bar.id = 'av-mobile-sticky-cart';
    bar.className = 'av-mobile-sticky-cart';
    bar.setAttribute('aria-label', 'פעולת רכישה מהירה');

    const price = document.createElement('span');
    price.className = 'av-mobile-sticky-cart__price';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'av-mobile-sticky-cart__button';

    bar.append(price, button);
    document.body.appendChild(bar);
    document.body.classList.add('av-sticky-cart-active');

    let frame = 0;
    const sync = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const currentButton = productInfo.querySelector('.product-form__submit');
        if (!currentButton) return;
        const label = currentButton.querySelector('span');
        button.textContent = (label ? label.textContent : currentButton.textContent)
          .trim()
          .replace(/\s+/g, ' ');
        button.disabled = currentButton.disabled || currentButton.getAttribute('aria-disabled') === 'true';
        price.textContent = visiblePrice(productInfo);
      });
    };

    button.addEventListener('click', () => {
      const currentButton = productInfo.querySelector('.product-form__submit');
      if (!currentButton || currentButton.disabled) return;
      currentButton.click();
    });

    const observer = new MutationObserver(sync);
    observer.observe(productInfo, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true
    });

    if ('IntersectionObserver' in window) {
      const visibilityObserver = new IntersectionObserver(
        (entries) => {
          bar.classList.toggle('is-hidden', entries[0].isIntersecting);
        },
        { threshold: 0.2 }
      );
      visibilityObserver.observe(originalButton);
    }

    sync();
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindFooterAccordions(document);
    setupStickyCart();
  });

  document.addEventListener('shopify:section:load', (event) => {
    bindFooterAccordions(event.target);
    window.setTimeout(setupStickyCart, 0);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const toggle = event.target.querySelector('.av-footer-toggle');
    if (toggle && mobileQuery.matches) toggle.setAttribute('aria-expanded', 'true');
  });
})();
